
<main>
    <div class="profile-details">
        <div class="profile-form">
            <form [formGroup]="sleepReminderForm">
                <div class="row">
                    <div class="form-group col-md-6">
                        <mat-form-field class="example-full-width w-100" appearance="outline">
                            <input matInput [ngxMatTimepicker]="picker1" formControlName="start_time" placeholder="પ્રારંભ સમય" #startTimeInput>
                            <ngx-mat-timepicker-toggle matSuffix [for]="picker1"></ngx-mat-timepicker-toggle>
                            <ngx-mat-timepicker #picker1></ngx-mat-timepicker>
                        </mat-form-field>
                        <div *ngIf="submitted && f.start_time.errors" class="error-message">
                            <small *ngIf="f.start_time.errors?.required" class="text-danger">પ્રારંભ સમય
                                જરૂરી છે.</small>
                        </div>
                    </div>
                    <div class="form-group col-md-6">
                        <mat-form-field class="example-full-width w-100" appearance="outline">
                            <input matInput [ngxMatTimepicker]="picker2" formControlName="end_time"
                                placeholder="સમાપ્તિ સમય">
                            <ngx-mat-timepicker-toggle matSuffix [for]="picker2"></ngx-mat-timepicker-toggle>
                            <ngx-mat-timepicker #picker2></ngx-mat-timepicker>
                        </mat-form-field>
                        <div *ngIf="submitted && f.end_time.errors" class="error-message">
                            <small *ngIf="f.end_time.errors?.required" class="text-danger">સમાપ્તિ સમય
                                જરૂરી છે.</small>
                        </div>
                    </div>
                </div>

                <div class="form-group">
                    <button type="submit" class="btn-common" *ngIf="buttonclick == false"
                        (click)="addSleepReminder()">નોંધણી
                        કરો</button>
                    <button type="submit" class="btn-common" *ngIf="buttonclick == true"
                        (click)="editSleepReminder()">નોંધણી
                        કરો</button>
                </div>
            </form>
        </div>
    </div>
    <div class="jobs">
        <hr>
        <div>
            <div class="main-members">
                <a class="member-list-item" *ngFor="let data of sleepHistoryData">
                    <div class="flex1">
                        <h5>પ્રારંભ સમય : {{ data.start_time }}</h5>
                        <h5>સમાપ્તિ સમય : {{ data.end_time }}</h5>
                    </div>
                    <i class="ti ti-pencil" (click)="editSleepData(data)"></i>
                    <mat-slide-toggle [(ngModel)]="data.is_active" class="example-margin"
                        [color]="data.is_active == 1? 'green' : 'red' " (change)="openDialog($event,data)">
                    </mat-slide-toggle>
                </a>
            </div>
        </div>
    </div>
</main>